export default __webpack_public_path__ + "static/media/Van30.5d01508b.webp";